import { Menu, X } from "lucide-react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Logo from "../assets/logo.png";
import "./Navbar.css";

const links = [
  ["Home", "home"],
  ["The Shift", "shift"],
  ["Artificial Intelligence", "ai"],
  ["Natural Human Intelligence", "nhi"],
  ["Principles", "principles"],
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== "/" || !location.hash) return;

    const id = location.hash.replace("#", "");

    const timeout = setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({
        behavior: "smooth",
      });
    }, 100);

    return () => clearTimeout(timeout);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const goTo = (id) => {
    setOpen?.(false);

    if (location.pathname !== "/") {
      navigate(`/#${id}`, {
        state: {
          skipIntro: true,
        },
      });

      return;
    }

    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
    });
  };
  return (
    <header className={`nav-header ${scrolled ? "nav-header--scrolled" : ""}`}>
      <div className="navbar__inner px-3 py-1">
        <button
          className="brand"
          type="button"
          onClick={() => navigate("/")}
          aria-label="Go to home"
        >
          <img src={Logo} className="logo-nav-header" />
        </button>

        <nav
          className={`navbar__links ${open ? "navbar__links--open" : ""}`}
          aria-label="Primary navigation"
        >
          {links.map(([label, id]) => (
            <button key={id} type="button" onClick={() => goTo(id)}>
              {label}
            </button>
          ))}
          {/* <a className="navbar__document" href="/docs/symphonia-brand-blueprint.pdf" target="_blank" rel="noreferrer">
            Read the blueprint
          </a> */}
          <a
            className="navbar__document"
            href="/TheLogo"
            target="_blank"
            rel="noreferrer"
          >
            The Logo
          </a>
        </nav>

        <button
          className="navbar-header__toggle"
          type="button"
          onClick={() => setOpen((value) => !value)}
          aria-label={open ? "Close navigation" : "Open navigation"}
          aria-expanded={open}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
    </header>
  );
}
